import { z } from 'zod'

export type School = z.infer<typeof SchoolSchema>
export const SchoolSchema = z.object({
  id: z.string(),
  name: z.string(),
  shortName: z.string(),
  color: z.string(),
  logoUrl: z.string().optional(),
  location: z.string(),
  totalCourses: z.number().optional(),
  totalProfessors: z.number().optional(),
  isActive: z.boolean(),
  addedAt: z.string(),
})
